import { takeEvery } from 'redux-saga/effects'
import fetchDomains from './fetch_domains'

function* domainSagas() {
  yield takeEvery("FETCH_DOMAINS", fetchDomains)
}

export default domainSagas